import React, { useState, useEffect } from 'react';
import './Header.css';
import logoJpg from './nv-logo.jpg';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.pageYOffset > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    document.body.classList.toggle('nav-open', isMenuOpen);
    return () => {
      document.body.classList.remove('nav-open');
    };
  }, [isMenuOpen]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const smoothScrollTo = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (!element) return;
    const headerEl = document.querySelector('.header');
    const headerOffset = headerEl ? headerEl.getBoundingClientRect().height : 80;
    const tickerEl = document.querySelector('.hero-info-bar');
    const tickerOffset = tickerEl ? tickerEl.getBoundingClientRect().height : 0;
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset - tickerOffset;
    window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
  };

  const scrollToSection = (e, sectionId) => {
    e.preventDefault();
    smoothScrollTo(sectionId);
    // Update hash for routing/permalinks
    if (window.history && window.history.pushState) {
      window.history.pushState(null, '', `#${sectionId}`);
    } else {
      window.location.hash = sectionId;
    }
    setIsMenuOpen(false);
  };

  // Handle initial hash and hash changes
  useEffect(() => {
    const handleHashScroll = () => {
      const hash = window.location.hash.replace('#', '');
      if (hash) {
        // Delay slightly to ensure layout is ready
        requestAnimationFrame(() => smoothScrollTo(hash));
      }
    };
    // On mount, if a hash exists, scroll to it
    handleHashScroll();
    // Listen to hash changes
    window.addEventListener('hashchange', handleHashScroll);
    return () => window.removeEventListener('hashchange', handleHashScroll);
  }, []);

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="header-content">
          <div className="logo">
            <span className="logo-badge">
              <img
                src={logoJpg}
                alt="NV Consulting Logo"
                className="primary-logo"
              />
            </span>
            <span>NV Consulting</span>
          </div>
          
          <nav className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
            <a href="#home" onClick={(e) => scrollToSection(e, 'home')}>Home</a>
            <a href="#services" onClick={(e) => scrollToSection(e, 'services')}>Services</a>
            <a href="#about" onClick={(e) => scrollToSection(e, 'about')}>About</a>
            <a href="#pricing" onClick={(e) => scrollToSection(e, 'pricing')}>Pricing</a>
            <a href="#contact" onClick={(e) => scrollToSection(e, 'contact')}>Contact</a>
            <button
              className="btn btn-primary"
              onClick={(e) => scrollToSection(e, 'contact')}
            >
              Get Started
            </button>
          </nav>

          <div
            className={`nav-overlay ${isMenuOpen ? 'active' : ''}`}
            onClick={() => setIsMenuOpen(false)}
          />

          <div className={`hamburger ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
